// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-card-text[data-v-7c9e96be] {\n  padding: 20px;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
